

import "@/x/tools/cryptojs.js"
import { showLoadingToast } from 'vant';
import eventBus from "@/x/tools/eventBus";
import WebRecorder from "@/libs/asr/webrecorder"
import SpeechRecognizer from "@/libs/asr/speechrecognizer"
import { ref } from "vue";
import { uint8ArrayToString, toUint8Array } from "@/x/tools";

export default function useAsr({ waveView = null, audioCallback = null, showLoading = true }) {
  let isCanStop;
	let isCanSendData = false;
  let recorder;
  let speechRecognizer;
	let resultText = '';
  const RECORD_STATE = {
    PENDING: 'pending',
    RECORDING: 'recording',
    RECOGNIZING: 'recognizing',
		RECORDED: 'recorded'
  }
  const ASRRecognizedState = ref(RECORD_STATE.PENDING)
  const ASRRecognizedText = ref("")

  function start() {
		resultText = ''
		ASRRecognizedState.value = RECORD_STATE.PENDING
		ASRRecognizedText.value = ''
    startRecord()
  }

  function startRecord() {
		let connectingToast = null;
		isCanSendData = false;
		if(showLoading) {
			connectingToast = showLoadingToast({
				message: '建立连接中...',
				forbidClick: true,
				position: "bottom"
			});
		}
		recorder = new WebRecorder();
		recorder.OnReceivedData = (audioData, waveData) => {
			// wave view
			if(waveView && waveView.value && isCanStop) {
				waveView.value.input(waveData, 100, 44100)
			}
			if(audioCallback) {
				audioCallback(audioData)
			}
      // 发送数据
			if(speechRecognizer && isCanSendData) speechRecognizer.write(audioData);
		};
		// 录音失败时
		recorder.OnError = (e) => {
			console.error("recorder error", e)
			recorder.stop();
		}
		recorder.start();
		if (!speechRecognizer) {
			speechRecognizer = new SpeechRecognizer({
        signCallback: signCallback, // 鉴权函数 用户提供鉴权函数，不传则为null
        // 用户参数
        secretid: process.env.VUE_APP_TENCENT_SECRET_ID,
        appid: process.env.VUE_APP_TENCENT_APPID,
        // 实时识别接口参数
        engine_model_type : '16k_zh-PY', // 中英粤混合引擎，使用一个引擎同时识别中文普通话、英语、粤语三个语言;
        voice_format : 1,
        // 以下为非必填参数，可跟据业务自行修改
        hotword_id : '08003a00000000000000000000000000',
        needvad: 1,
        filter_dirty: 1,
        filter_modal: 2,
        filter_punc: 0,
        convert_num_mode : 1,
        word_info: 2
      });
		}
		// 开始识别
		speechRecognizer.OnRecognitionStart = (res) => {
			console.log('开始识别', res);
			connectingToast?.close()
			isCanStop = true;
			isCanSendData = true;
      ASRRecognizedState.value = RECORD_STATE.RECORDING
		};
		// 识别变化时
		speechRecognizer.OnRecognitionResultChange = (res) => {
			console.error("OnRecognitionResultChange", res);
			const currentText = `${resultText}${res.result.voice_text_str}`;
      ASRRecognizedText.value = currentText;
		};
		// 一段话结束
		speechRecognizer.OnSentenceEnd = (res) => {
			console.error("OnSentenceEnd", res);
			resultText += res.result.voice_text_str;
			ASRRecognizedText.value = resultText;
		}
		// 识别结束
		speechRecognizer.OnRecognitionComplete = (res) => {
			console.log('识别结束', res);
			isCanSendData = false;
			eventBus.emit('end-asr', res);
		};
		// 识别错误
		speechRecognizer.OnError = (res) => {
			console.log('识别失败', res);
			isCanSendData = false;
      ASRRecognizedState.value = RECORD_STATE.PENDING;
		};
		// 建立连接
		speechRecognizer.start();
		// ASRRecognizedState.value = RECORD_STATE.CONNECTING
	}

  function stop() {
    if (recorder) {
      recorder.stop();
    }
		if (isCanStop) {
			speechRecognizer.stop();
		}
		isCanStop = false
		// 停止时放入空数据 重置波形
		if(waveView && waveView.value) {
			waveView.value.input(new Int16Array(1440), 100, 44100)
		}
		if(audioCallback) {
			audioCallback()
		}
  }

  function signCallback(signStr) {
    const secretKey = process.env.VUE_APP_TENCENT_SECRET_KEY;
    const hash = window.CryptoJS.HmacSHA1(signStr, secretKey);
    const bytes = uint8ArrayToString(toUint8Array(hash));
    return window.btoa(bytes);
  }

  return {
    start,
    stop,
    ASRRecognizedText,
		ASRRecognizedState
  }
}